// @ts-ignore
import Config from 'Config';
import QueryString from 'qs';
import xhr from 'xhr';
import { isEmpty } from 'lodash';
// @ts-ignore
import { getCsrfTokenFromCookies, getCommonHeaders } from 'lib/requestHeaders';
// @ts-ignore
import { serviceUnavailable } from 'lib/retryLaterHelper';
// @ts-ignore
import { checkInterception } from 'singletons/xhrInterceptors';

export const remindXHR = { xhr };

const API_HOST = Config.Environment.R101_API_URL;
const PATH_PREFIX = '/v2';

function encodeData(data: any) {
  return QueryString.stringify(data, {
    arrayFormat: 'brackets',
  });
}

export function getAPIURL(endpoint: string): string {
  return API_HOST + PATH_PREFIX + endpoint;
}

export default function apiRequest(
  endpoint: string,
  method: string = 'GET',
  data: { [keys in string]: any } = {},
  isJSON: boolean = true
): Promise<any> {
  if (serviceUnavailable(endpoint)) {
    return Promise.reject(new Error('Service Unavailable'));
  }

  const csrfToken = getCsrfTokenFromCookies();
  const urlParams: { [keys in string]: any } = {};

  return new Promise(function(resolve, reject) {
    const options: { [keys in string]: any } = {
      url: getAPIURL(endpoint),
      method,
      headers: {
        ...getCommonHeaders(csrfToken),
        'Content-Type': isJSON
          ? 'application/json; charset=utf-8'
          : 'application/x-www-form-urlencoded; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
      timeout: 30 * 1000,
    };

    // Limit API requests to GET and POST requests only. We use the `X-HTTP-Method-Override` to
    // alter the HTTP method when proxying to API.
    if (method !== 'GET' && method !== 'POST') {
      options.method = 'POST';
      options.headers['X-HTTP-Method-Override'] = method;
    }

    // XXX remove stores from API lib
    const CurrentUser = require('auth/CurrentUser').default;
    if (CurrentUser.getToken()) {
      urlParams['token'] = CurrentUser.getToken();
    } // This behavior is otherwise deprecated and should not be relied on.

    // always omit undefined
    // XXX We allow explicitly setting null to accomodate de-linking a class from an org. 💩
    for (const key in data) {
      if (data[key] === undefined || (method === 'GET' && data[key] === null)) {
        delete data[key];
      }
    }
    if (method === 'GET') {
      if (data) {
        Object.assign(urlParams, data);
        data = {}; // eslint-disable-line no-param-reassign
      }
    }
    if (!isEmpty(urlParams)) {
      options.url += '?' + encodeData(urlParams);
    }
    if (isJSON) {
      options.json = data;
    } else {
      options.body = encodeData(data);
    }
    // @ts-ignore
    remindXHR.xhr(options, function(err, response, body) {
      // A status code of `0` typically means that the xhr request was cancelled.
      // Don't handle these as they'll typically result in errors being produced.
      if (response.statusCode === 0) {
        return;
      }
      if (!isJSON) {
        try {
          body = JSON.parse(body); // eslint-disable-line no-param-reassign
        } catch (e) {
          // Do nothing.
        }
      }
      const intercepted = checkInterception(response, endpoint);
      if (!intercepted) {
        if (err || response.statusCode >= 400) {
          // TODO: Wrap the error response into something easier to use.
          if (body && typeof body === 'object') {
            body.statusCode = response.statusCode;
          }
          reject(err || body);
        } else {
          resolve(body);
        }
      }
    });
  });
}
